import { t } from 'i18next'
import { getPlaceOptions } from 'lib/utils'
import { useEffect, useState } from 'react'

const statusMenuOptions = [
  {
    key: 'status',
    status: 0,
    label: 'orderStatus.init',
  },
  {
    key: 'status',
    status: 1,
    label: 'orderStatus.open',
  },
  {
    key: 'status',
    status: 3,
    label: 'orderStatus.processing',
  },
  {
    key: 'status',
    status: 5,
    label: 'orderStatus.delivered',
  },
  {
    key: 'status',
    status: 6,
    label: 'orderStatus.cancelled',
  },
]

const stringMenuOptions = [
  {
    key: 'customer_name',
    label: 'searchContent.customerName',
  },
  {
    key: 'customer_email',
    label: 'searchContent.customerEmail',
  },
]

const numericMenuOptions = [
  {
    key: 'order_id',
    label: 'searchContent.orderId',
  },
  {
    key: 'part_id',
    label: 'searchContent.partId',
  },
  {
    key: 'visible_id',
    label: 'searchContent.visibleId',
  },
]

export const useSearchMenuOptions = (
  input: string,
  places: { label: string; value: string }[]
) => {
  const [menuOptions, setMenuOptions] = useState<
    {
      key: string
      label: string
      placeId?: string
      placeName?: string
      status?: number
    }[]
  >([])

  const formatMenuOptions = () => {
    if (Number.isNaN(Number(input))) {
      const matchedStatus = statusMenuOptions.filter((status) => {
        return t(status.label).toLowerCase().includes(input.toLowerCase())
      })
      const placeOptions = getPlaceOptions(places)
      setMenuOptions([...stringMenuOptions, ...placeOptions, ...matchedStatus])
    } else {
      setMenuOptions(numericMenuOptions)
    }
  }

  useEffect(() => {
    formatMenuOptions()
  }, [input, places])

  return { menuOptions }
}
